module.exports = __webpack_public_path__ + "img/身份验证完.b09fb59b.png";